/* global require */
<template>
	<AddAsg ref="addAsgModal" @onAddAsg="toogleAddAsgLoader" />
	<TenantReg ref="tenantModal" @onRegisterload="onRegisterload" />
	<div class="backgroundGrey" v-show="showList"></div>
	<div class="myLoadBack" style="z-index:9999999" v-show="showregloader">
		<div class="d-flex align-items-center justify-content-center h-100">
			<pageLoaderComp></pageLoaderComp>
		</div>
	</div>
	<div class="modal-content listHolder" v-show="showList">
		<div class="modal-header">
			<h4 class="modal-title">Own and Shared Assessment List for Tenant</h4>
			<div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close" v-on:click="showList = !showList;">
				<div class="leftright"></div>
				<div class="rightleft"></div>
			</div>
		</div>
		<div class="modal-body" style="height:75vh;overflow-y: auto;overflow-x: hidden;">
			<div class="text-end">
				<a v-on:click="GetassessmentData(1)" class="myRefLst nonEffect" style="margin-top:10px;">Refresh
					List</a>
			</div>
			<div v-if="showTable">
				<ag-grid-vue style="height:310px;" class="table-striped thmHead v01 ag-theme-alpine myHomeTable"
					:columnDefs="asgcolsDefs" :modules="modules" @grid-ready="onPriorAsg" @cell-clicked="checkCellClick">
				</ag-grid-vue>
			</div>
		</div>
	</div>
	<div class="modal-content listHolder" v-show="showReminderList">
		<div class="modal-header">
			<h4 class="modal-title">List of Tenants</h4>
			<div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
				v-on:click="showReminderList = !showReminderList;">
				<div class="leftright"></div>
				<div class="rightleft"></div>
			</div>
		</div>
		<div class="modal-body" style="height:75vh;overflow-y: auto;overflow-x: hidden;">
			<table class="table-striped thmHead v01 ag-theme-alpine expiry-date">
				<thead>
					<tr>
						<td> Tenant Name</td>
						<td> Current Status</td>
						<td> Due Date</td>
						<td> Remind/Request</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="bus in BU_list.sort()" v-bind:key="bus.unit">
						<td>{{ bus.unit }}</td>
						<td>{{ bus.status }}</td>
						<td>{{ bus.due_date }}</td>
						<td class="d-flex align-items-center"><input type="checkbox" v-model="bus.shouldActiviate" class="option-input radio"> </td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="modal-footer">
			<div class="effect btn-add eff-md me-2" v-on:click="sendRequest()">Send Request</div>
			<div class="btn stdBtn btn-bordered" data-dismiss="modal" aria-label="Close"
				v-on:click="closeAprPop()" type="button">
				<b>Cancel</b>
			</div>
		</div>
	</div>
	<div v-if="activateErr == 1 || activateErr == 2">
		<div class="msgClass301 text-center" style="bottom: 25%;">
			<h3>
				<span v-html="actMsg"></span>.
				<br>
				<span v-if="activateErr == 1">
					Click <a class="cursor-pointer mailLink" v-on:click="emailAdmin()">here</a> to contact Admin Team.
				</span>
				<span v-else>
					Click <a class="cursor-pointer mailLink" v-on:click="emailAdmin()">here</a> to contact Admin Team with
					reason if this is urgent.
				</span>
				<br><br>
				Click <a class="cursor-pointer mailLink" v-on:click="logoutFromBack()">here</a> to Logout
			</h3>
		</div>
		<div class="BlurClass301">
			<div class="loop-wrapper">
				<div class="mountain"></div>
				<div class="hill"></div>
				<div class="tree"></div>
				<div class="tree"></div>
				<div class="tree"></div>
				<div class="rock"></div>
				<div class="truck"></div>
				<div class="wheels"></div>
			</div>
		</div>
	</div>
	<div class="myGradBack">
		<div class="greetingMsgD">
			{{ greetingMsg }},&nbsp;<b>{{ UserName }} </b>
			<a v-if="activateErr == 0" class="secondaryTxt greetingMsgTnt" v-on:click="regTenantOpn(1)">
				({{ curr_bu }}
				<font-awesome-icon :icon="['fas', 'briefcase']" />)</a>
		</div>
		<div class="myHdrIcon">
			<span class="drpSett admopn" v-if="isAdmin == 1 || isAppmAdmin ==1" aria-label="Admin Page" data-balloon-pos="down">
				<router-link to="/admin">
					<font-awesome-icon :icon="['fas', 'user-cog']" class="headerIcons" />
				</router-link>
			</span>
		</div>
		<div class="myLoadBack" v-show="ishmload">
			<div class="d-flex align-items-center justify-content-center h-100">
				<pageLoaderComp></pageLoaderComp>
			</div>
		</div>
		<div class="row g-0" style="margin-top:55px">
			<div class="col-12 text-end">
				<div class="effect btn-list eff-xl" v-on:click="GetassessmentData()" style="margin-right:15px;">View
					Assessment List</div>
				<div class="effect Inverse btn-add eff-xl" v-on:click="AddAssessment()" style="margin-right:15px;">
					Create New Assessment</div>
			</div>
		</div>
		<div class="jumbotron srchBackground">
			<div class="container-fluid">
				<div class="row glassBoxHolder" v-if="Freshacc">
					<div class="col-12 text-center">
						<div class="" v-if="BuExists">
							<div class="mySearchLogoL text-center">
								<b style="display: flex;width: 100%; margin: auto;justify-content: center;">
									<!-- <span class="brandName">
										<img src="../assets/images/Canvas-NOlockup_BLK.svg" v-show="$store.state.TClrs != 'darkTheme'"
											class="canvasLogo">
										<img src="../assets/images/Canvas-NOlockup_WHT.svg" v-show="$store.state.TClrs == 'darkTheme'"
											class="canvasLogo">
										&nbsp;&nbsp;&nbsp;</span> -->
									<span
										style="transform: scale(0.16);display: inline-block;width: 90px;margin-top: -37px;margin-left: -65px;margin-right: 10px;">
										<svg width="312px" height="312px" style="margin-top: -125px;display: inline-block;">
											<!-- Center color -->
											<circle cx="156" cy="156" r="125" fill="transparent" id="radius" />
											<!-- 100% fill -->
											<circle cx="156" cy="156" r="125" fill="transparent" stroke-width="52" stroke="#ecc257"
												data-fill="100" class="progressL" />
											<!-- 81% filled -->
											<circle cx="156" cy="156" r="125" fill="transparent" stroke-width="52" stroke="#11a8ab"
												data-fill="66" class="progressL" transform='rotate(-90 156 156)' />
											<!-- 32% filled -->
											<circle cx="156" cy="156" r="125" fill="transparent" stroke-width="52" stroke="#e64c65"
												data-fill="33" class="progressL" transform='rotate(-90 156 156)' />
										</svg>
									</span>
									<span class="myAppCan">
										<div class="shimmer">PSIGHT</div>
									</span>
								</b>
							</div>
						</div>
						<form class="home-form">
							<div class="input-group mySearchGrp">
								<vue3-simple-typeahead class="form-control searchbox" id="typeahead_id"
									placeholder="Search existing assessments here" :items="asgsuggesstion" :minInputLength="1"
									:itemProjection="(item) => { return item.Name }" @selectItem="asgSelect" @onInput="getsuggesstion">
									<template #list-item-text="slot">
										<span class="kingKong" v-html="slot.boldMatchText(slot.itemProjection(slot.item))"></span>
									</template>
								</vue3-simple-typeahead>
								<div class="input-group-append">
									<span class="input-group-text mygrad" id="inputGroupPrepend">
										<i class="fa fa-search" aria-hidden="true"></i>
									</span>
								</div>
							</div>
							<div v-show="NoAssessment">
								<label v-if="!asgsuggesstion" class="text-danger">No Assessment with name
									<b>"{{ AsgObjOpName }}"</b>exists</label>
							</div>
						</form>
						<div style="margin-top: 20px;width: 75%;margin: auto;">
							<section>
								<div class="row bkHldr" style="margin-top: 10px; overflow: auto; min-height: 0; max-height: 120px;">
									<div v-for="val in BookMarkList" :key="val" class="myCard col col-6 col-sm-4 col-lg-3"
										v-on:mouseover="hoverclose = true" v-on:mouseleave="hoverclose = false">
										<div class="text-center">
											<div class="assessmentIcon" style="position: relative;">
												<div class="myCardClose" v-on:click="GetbookMarkData(1, val.id)">
													<font-awesome-icon :icon="['fas', 'times']" />
												</div>
												<router-link v-bind:to="val.isuploaded > 0 ? '/insights/' + val.id : '/setup/' + val.id">
													<span class="assessafter">
														<font-awesome-icon icon="fa-solid fa-bookmark" />
													</span>
													<font-awesome-icon :icon="['fas', 'chart-line']" class="fas" />
												</router-link>
											</div>
											<router-link v-bind:to="val.isuploaded > 0 ? '/insights/' + val.id : '/setup/' + val.id">
												<div class="assessmentName" title="{{val.name}}">{{ val.name }}</div>
											</router-link>
										</div>
									</div>
								</div>
							</section>
							<div style="display: none;">
								<ag-grid-vue style="height:270px;" class="table-striped thmHead v01 ag-theme-alpine myHomeTable"
									:columnDefs="asgcolsDefs" :modules="modules" @grid-ready="onPriorAsg" @cell-clicked="checkCellClick">
								</ag-grid-vue>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import AddAsg from '../components/addAsg.vue'
import TenantReg from '../components/regTenant.vue'
import { AgGridVue } from "@ag-grid-community/vue3";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import pageLoaderComp from '../components/smallcomp/pageloader.vue'
const cols = [{
	headerName: "Assessment Name",
	suppressSizeToFit: true,
	field: "name",
	sortable: true,
	filter: 'agTextColumnFilter',
	filterParams: {
		buttons: ['reset', 'apply']
	},
	cellRenderer: params => {
		return '<span class="uSpl">' + params.value + '</span>';
	}
},
{
	headerName: "Ticket Count",
	type: 'numericColumn',
	suppressSizeToFit: true,
	field: "tic_cnt",
	sortable: true,
	filter: 'agNumberColumnFilter',
	filterParams: {
		buttons: ['reset', 'apply']
	},
	cellRenderer: params => {
		return parseInt(params.value).toLocaleString();
	}
},
{
	headerName: "Created By",
	suppressSizeToFit: true,
	field: "cret_by",
	sortable: true,
	filter: 'agTextColumnFilter',
	filterParams: {
		buttons: ['reset', 'apply']
	}
},
{
	headerName: "isuploaded",
	suppressSizeToFit: true,
	field: "isuploaded",
	hide: true,
},
{
	headerName: "Access level",
	suppressSizeToFit: true,
	field: "access_lvl",
	sortable: true,
	filter: 'agTextColumnFilter',
	filterParams: {
		buttons: ['reset', 'apply']
	}
},
{
	headerName: "Toogle View Bookmark",
	field: "cret_by",
	cellRenderer: params => {
		// put the value in bold
		if (params.data.issel) {
			return ''
		} else if (!params.data.bookmarked) {
			return '<span><svg class="svg-inline--fa fa-bookmark myfaBtn listIcon" aria-hidden="true" focusable="false" data-prefix="far" data-icon="bookmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"></path></svg></span>';
		} else {
			return '<span><svg class="svg-inline--fa fa-bookmark myfaBtn listIcon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bookmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"></path></svg></span>';
		}
	}
}
];
import userinMix from '../mixin/userinMix'
import Analytics from './analytics.vue';
export default {
	inheritAttrs: false,
	name: 'homePage',
	mixins: [userinMix],
	components: {
		AddAsg,
		TenantReg,
		AgGridVue,
		pageLoaderComp
	},
	data() {
		return {
			hmeload: false,
			activateErr: 0,
			actMsg: "Sorry your account got expired",
			modules: [ClientSideRowModelModule],
			myDate: '',
			hrs: '',
			greetingMsg: '',
			UserName: "",
			assessmentCount: 0,
			showregloader: false,
			isAdmin: 0,
			isAppmAdmin: 0,
			isAnalytics: 1,
			ishmload: true,
			UserInfo: {},
			business: [],
			Freshacc: true,
			BuExists: false,
			isLight: false,
			BU_list: [],
			curr_bu: "",
			NoAssessment: false,
			AsgObjOpName: null,
			BookMarkList: [],
			Is_bookmark: "",
			hoverclose: false,
			asgsuggesstion: [],
			selectedUser: null,
			shwregister: false,
			showTable: false,
			headername: "",
			asgLisApi: null,
			asgLis: null,
			asgcolsDefs: cols,
			showList: false,
			showReminderList: false,
		}
	},
	created() {
		this.myDate = new Date()
		this.onUserValdiate()
	},
	methods: {
		getAccAndTech(){
			this.$refs.addAsgModal.userinput()
		},
		closeAprPop(){
			this.showReminderList = !this.showReminderList;
			let clist = document.getElementsByClassName("option-input");
				for (let i = 0; i < clist.length; ++i) {
					clist[i].checked = false;
			}
		},
		onRegisterload(showregloader) {
			this.showregloader = showregloader.loader;
		},
		toogleAddAsgLoader(showregloader) {
			this.showregloader = showregloader;
		},
		getGreet() {
			this.hrs = this.myDate.getHours();
			if (this.hrs < 12)
				this.greetingMsg = 'Good Morning';
			else if (this.hrs >= 12 && this.hrs <= 16)
				this.greetingMsg = 'Good Afternoon';
			else if (this.hrs >= 16 && this.hrs <= 24)
				this.greetingMsg = 'Good Evening';
		},
		clearAllCookies() {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    },
		logoutFromBack(){
			this.ishmload = true;
			const allCookies = document.cookie;
			const cookieArray = allCookies.split('; ');
			let kcToken;
			for (let i = 0; i < cookieArray.length; i++) {
				const cookie = cookieArray[i].split('=');
				if (cookie[0] === 'keycloakToken') {
					kcToken = cookie[1];
					break;
				}
			}
			let UVobj = {"token": kcToken}
			this.axios.post(this.uriApiUrl + 'UserSetting/logout?',UVobj,{
			headers: {
					'Content-Type': 'application/json'
				}})
				.then((response) => {
					if (response.status == 200) {
						if (response.data != "Error") {
							this.logOut()
							this.ishmload = false;
							this.$notify({
								type: "info",
								text: 'logout successfully.'
							})
						}
					}
				}).catch((error) => {
					this.ishmload = false;
					this.clearAllCookies();
					sessionStorage.clear();
					localStorage.clear();
					this.$notify({
						type: "error",
						text: 'Error.'
					})
				})
		},
		logOut() {
			this.clearAllCookies();
			sessionStorage.clear();
			localStorage.clear();
			this.$keycloak.logout();
		},
		emailAdmin() {
			this.showReminderList = true;
		},
		sendRequest() {
			this.showregloader = true;
			let checkedBUList = this.BU_list.filter(item => item.shouldActiviate)
			let Bu_data = {
				"Bu_list": checkedBUList
			}
			this.axios.post(this.uriApiUrl + 'UserSetting/request_access', Bu_data,{
      headers: {
            'Content-Type': 'application/json'
          }})
				.then((response) => {
					if (response.status == 200) {
				if (response.data == "Error") {
					this.showregloader = false;
                  this.$notify({
                    type: "error",
                    text: "Request failed! Please try again after sometime"
                  })
                }else{
					this.showregloader = false;
					this.showReminderList = false;
					let clist = document.getElementsByClassName("option-input");
					for (let i = 0; i < clist.length; ++i) {
						clist[i].checked = false;
					}
					this.$notify({
						type: "success",
						text: 'Request sent successfully.'
					})
				}
					}
				}).catch((error) => {
					this.showregloader = false;
					this.$notify({
						type: "error",
						text: "Request failed!Try After Some Time"
					})
				})
		},
		getsuggesstion(event) {
			this.axios.get(this.uriApiUrl + "UserSetting/search_assessment?Keyword=" + event.input,{
      headers: {
            'Content-Type': 'application/json'
          }})
				.then((response) => {
					this.asgsuggesstion = response.data.SearchData
					if (this.asgsuggesstion.length == 0) {
						this.NoAssessment = false
					} else {
						this.NoAssessment = true
					}
				})
		},
		checkCellClick(params) {
			if (params.column.colDef.headerName == "Assessment Name") {
				this.asgSelect(params)
			} else if (params.column.colDef.headerName == "Toogle View Bookmark") {
				this.bookMarkClick(params.data.id, params.data.name, params.data.isuploaded, params.rowIndex)
			}
		},
		bookMarkClick(id, name, isUploaded, rowNo) {
			this.axios.get(this.uriApiUrl + 'UserSetting/save_bookmarks?asg_id=' + id,{
      headers: {
            'Content-Type': 'application/json'
          }})
				.then((response) => {
					if (response.status == 200) {
						if (response.data == 'Yes') {
							this.Is_bookmark = 'Yes'
							this.BookMarkList.push({
								id: id,
								isuploaded: isUploaded,
								name: name
							})
							this.$notify({
								type: "success",
								text: "\" " + name + " \" Assesssment Bookmarked!"
							})
						} else if (response.data == 'No') {
							this.Is_bookmark = 'No'
							let removeIdx;
							for (let index = 0; index < this.BookMarkList.length; index++) {
								const element = this.BookMarkList[index];
								if (element.id == id) {
									removeIdx = index;
								}
							}
							this.BookMarkList.splice(removeIdx, 1);
							this.$notify({
								type: "error",
								text: "\" " + name + " \" Assesssment BookMark Removed!"
							})
						}
						this.GetassessmentData();
					}
				}).catch((error) => {
					this.$notify({
						type: "error",
						text: "Not able to add/Remove BookMark!Try After Some Time"
					})
				})
		},
		asgSelect(event) {
			if (event.data) {
				if (event.data.isuploaded > 0) {
					this.$router.push("/insights/" + event.data.id)
				} else {
					this.$router.push("/setup/" + event.data.id)
				}
			} else {
				if (event.isuploaded > 0) {
					this.$router.push("/insights/" + event.Value)
				} else {
					this.$router.push("/setup/" + event.Value)
				}
			}
		},
		AddAssessment() {
			this.$refs.addAsgModal.showModal()
		},
		regTenantOpn(val) {
			if (val == 0) {
				this.shwregister = true;
				this.headername = "Register Tenant"
			} else {
				this.shwregister = false;
				this.headername = "Choose Your Tenant"
			}
			this.$refs.tenantModal.showRegModal(this.shwregister, this.headername)
		},
		GetbookMarkData(Cond, removeID) {
			this.ishmload = true;
			this.axios.get(this.uriApiUrl + "UserSetting/get_bookmarks?Cond=" + Cond + "&removeID=" + removeID,{
      headers: {
            'Content-Type': 'application/json'
          }})
				.then((response) => {
					if (Cond == 0) {
						if (response.data != "Error") {
							this.BookMarkList = response.data;
						} else if (response.data == "Error") {
							this.$notify({
								type: "error",
								text: 'Not able to Retrive BookMark!'
							})
						}
					} else {
						if (response.data == "Success") {
							let removeIdx;
							for (let index = 0; index < this.BookMarkList.length; index++) {
								const element = this.BookMarkList[index];
								if (element.id == removeID) {
									removeIdx = index;
								}
							}
							this.BookMarkList.splice(removeIdx, 1);
							this.$notify({
								type: "success",
								text: 'BookMark Deleted!'
							})
							this.Is_bookmark = 'No';
						} else {
							this.$notify({
								type: "error",
								text: 'Not able to Delete BookMark!'
							})
						}
					}
					this.ishmload = false;
				}).catch((error) => {
					this.$notify({
						type: "error",
						text: 'Not able to Delete BookMark!'
					})
					this.ishmload = false;
				})
		},
		onUserValdiate() {
			this.ishmload = true
			let UVobj = {"Base_Color": "Dark"}
			this.axios.post(this.uriApiUrl + 'UserSetting/getuserdetails?',UVobj,{
				headers: {
						'Content-Type': 'application/json'
					}})
				.then((response) => {
					if (response.status == 200) {
						this.userInfo = response.data
					}
					this.getGreet();
					if (this.userInfo == "Error") {
						this.$notify({
							type: "error",
							title: '<i class="fa fa-warning"></i>',
							text: 'Sorry! Something went Wrong! Please try after few minutes'
						})
					} else if (this.userInfo.userstatus == "Newaccount") {
						this.Freshacc = false
						this.activateErr = 1
						this.BuExists = false
						this.$sessionData.set('uinofo_sess', this.userInfo)
						this.business = this.userInfo.All_BU
						this.BU_list = this.userInfo.BU_list
						this.UserName = this.userInfo.UserName
						this.actMsg =
							"Thanks for registering in OPSight. Your account is not activated yet.<br/> This is normally done by the tenant admin within 24 hrs."
						this.regTenantOpn(0)
					} else if (this.userInfo.userstatus == "NotApproved") {
						this.Freshacc = false
						this.activateErr = 2
						this.BuExists = false
						this.$sessionData.set('uinofo_sess', this.userInfo)
						this.business = this.userInfo.All_BU
						this.BU_list = this.userInfo.BU_list
						this.UserName = this.userInfo.UserName
						this.actMsg =
							"Your account has not been activated yet.<br/> This is normally done by the tenant admin within 24 hrs."
					} else if (this.userInfo.userstatus == "BUexpired") {
						this.Freshacc = false
						this.activateErr = 1
						this.BuExists = false
						this.$sessionData.set('uinofo_sess', this.userInfo)
						this.business = this.userInfo.All_BU
						this.BU_list = this.userInfo.BU_list
						this.UserName = this.userInfo.UserName
						this.curr_bu = this.userInfo.Curr_BU
						this.actMsg = "Sorry your account got expired"
					} else {
						this.Freshacc = true
						this.activateErr = 0
						this.BuExists = true
						this.$sessionData.set('uinofo_sess', this.userInfo)
						this.business = this.userInfo.All_BU
						this.BU_list = this.userInfo.BU_list
						this.UserName = this.userInfo.UserName
						this.isAdmin = this.userInfo.is_admin
						this.isAppmAdmin = this.userInfo.is_appm_admin
						this.assessmentCount = this.userInfo.assessmentCount
						this.curr_bu = this.userInfo.Curr_BU
						this.$emit("getflname", this.userInfo.UserName, this.userInfo.base_Color)
						this.isLight = this.userInfo.base_Color == "dark"
						this.GetbookMarkData(0, 1)
						this.$notify({
							type: "info",
							title: '<i class="fa fa-info"></i>&nbsp; Hi! ' + this.UserName + ' <br> ',
							text: 'Logged In Successfully',
						})
						let chkFilterOn = this.userInfo.BU_list.find(element => element.unit == this.userInfo.Curr_BU)
						let BuExpiryDate = new Date(chkFilterOn.due_date);
						let todayDate = new Date();
						let Difference_In_Time = BuExpiryDate.getTime() - todayDate.getTime();
						let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
						// console.log(Math.trunc(Difference_In_Days));
						let daysValue = Math.trunc(Difference_In_Days)
						if (0 >= daysValue) {
							this.$notify({
								type: "error",
								title: 'Your account is expired.',
								text: 'Please renew the account.',
								duration: -1
							})
						} else if (7 >= daysValue) {
							this.$notify({
								type: "error",
								text: '<i class="fa fa-exclamation-triangle"></i>&nbsp;Your Account Will expired in ' + daysValue + ' Days.',
								duration: -1
							})
						} else if (15 >= daysValue) {
							this.$notify({
								type: "warn",
								text: '<i class="fa fa-exclamation-circle"></i>&nbsp;Your Account will expire in ' + daysValue + ' Days.',
								duration: -1
							})
						}
					}
					this.ishmload = false;
				})
				.catch((error) => {
					this.$notify({
						type: "error",
						text: 'Something went Wrong!Login again'
					})
					this.ishmload = false;
				})
		},
		contactExpire() {
			var subject = "Opsight Azure GA Support : Grant/Renew Access";
			var yourMessage = "Hi Support Team," +
				"\n\n Requesting you to provide grant/renew access for tenant. Kindly find the Below details:\n";
			yourMessage += "User : " + this.userInfo.UserName + "\n";
			yourMessage += "Tenant : <Please mention Tenant(s)>";
			document.location.href = this.userInfo.mailto +
				encodeURIComponent(subject) +
				"&body=" + encodeURIComponent(yourMessage);
		},
		GetassessmentData() {
			this.ishmload = true;
			this.showTable = true;
			let UVobj = {"Base_Color": "Dark"}
			this.axios.post(this.uriApiUrl + 'UserSetting/getassesmentdet?',UVobj,{
			headers: {
					'Content-Type': 'application/json'
				}})
				.then((response) => {
					if (response.status == 200) {
						if (response.data != "Error") {
							this.asgLis = response.data
							setTimeout(() => {
								this.asgLisApi.setRowData(this.asgLis)

								this.ishmload = false;
								this.showList = true;

							}, 100);
						}
					}
				}).catch((error) => {
					this.$notify({
						type: "error",
						text: 'Unable to Load Assessment List.'
					})
					this.ishmload = false;
				})
		},
		onPriorAsg(params) {
			this.asgLisApi = params.api
			this.gridColumnApi = params.columnApi
		},
	},
	watch: {},
	mounted() {
		animationOn = setInterval(() => {
			if (document.getElementById("radius") != null && document.getElementById("radius") !=
				undefined) {
				getAnimation()
				clearInterval(animationOn)
			}
		}, 100);
	}
}
var animationOn
function getAnimation() {
	var radius = parseInt($("#radius").attr("r")) // Get the radius of the circle
	var perimeter = 2 * 3.14 * radius;
	$(".progressL").each(function () {
		var amount = parseFloat($(this).attr("data-fill"));
		var fillAmount = perimeter - perimeter * amount / 100;
		$(this).attr({
			"stroke-dasharray": perimeter,
			"stroke-dashoffset": perimeter
		})
		$(this).animate({
			"stroke-dashoffset": fillAmount
		}, 1500, "swing")
	})
}
</script>
<style scoped>
.myHdrIcon {
	display: inline-block;
	/* width: 50px; */
	position: fixed;
	right: 126px;
	/* font-size: 30px; */
	padding: 5px 0px 0px;
	z-index: 1031;
	top: -5px;
}

.glassBoxHolder {
	/* height: calc(100vh - 50px); */
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
}

.jumbotron.srchBackground {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -60%);
	margin-top: 48px;
}

.listHolder {
	width: 70%;
	margin: 50px 15% auto;
	z-index: 99999;
	height: 500px;
	position: fixed;
	top:0;
}

.input-group-append {
	position: absolute;
	right: 0;
}

span#inputGroupPrepend {
	background: none;
	width: 45px;
	border: none;
	padding: 0.6rem 0.75rem;
}

.canvasLogo {
	height: 25px;
	margin-top: 43px;
}
.darkTheme .expiry-date thead,.darkTheme .expiry-date tbody,.darkTheme .expiry-date tfoot,.darkTheme .expiry-date tr,.darkTheme .expiry-date td,.darkTheme .expiry-date th{
	color: #fff;
}
.expiry-date tr{
	height:20px;
}
.option-input {
	top:0;
}
.darkTheme .expiry-date thead td{
	font-weight: 700;
	padding:5px;
	font-size:16px
}
.myLoadBack {
	z-index: 999999;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>